import { FooterResponse } from "@entities/domains/footer.entity";
import { Observable } from "rxjs";

export abstract class FooterRepository {
  abstract GetFooter(): Observable<FooterResponse>;
}
